import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import DropDownIconSvg from '../Svgs/DropdownIcon.svg';
import './MultiSelector.scss';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const PLANS = [
  {
    lable: 'Radio',
    value: 'Radio',
  },

  {
    lable: 'Unlimited',
    value: 'Unlimited',
  },
];

function MultipleSelectCheckmarks({ onChange }) {
  const [type, setType] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    const values = typeof value === 'string' ? value.split(',') : value;
    const UppercaseValues = values.map((val) => val.toUpperCase());

    setType(typeof value === 'string' ? value.split(',') : value);
    onChange(UppercaseValues);
  };

  return (
    <div>
      <FormControl sx={{ my: 3 }} className="input">
        <Select
          className="mui-selectBox"
          multiple
          displayEmpty
          value={type}
          onChange={handleChange}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <span className="dropdown_text">Select plans to upload songs</span>;
            }

            return selected.join(', ');
          }}
          MenuProps={MenuProps}
          inputProps={{ 'aria-label': 'Without label' }}
          IconComponent={DropDownIconSvg}
        >
          {PLANS.map((plan) => (
            <MenuItem key={plan.value} value={plan.value}>
              <Checkbox checked={type.indexOf(plan.value) !== -1} style={{ color: '#40189D' }} />
              <ListItemText primary={plan.lable} className="custom_Menu_Item" />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default MultipleSelectCheckmarks;
